import { render, staticRenderFns } from "./DelegationAgreement.vue?vue&type=template&id=5fcdaaff&scoped=true"
import script from "./DelegationAgreement.vue?vue&type=script&lang=js"
export * from "./DelegationAgreement.vue?vue&type=script&lang=js"
import style0 from "./DelegationAgreement.vue?vue&type=style&index=0&id=5fcdaaff&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fcdaaff",
  null
  
)

export default component.exports